<template>
  <div class="container">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/websites' }">概览</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/websites/dnspod' }">域名管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ domain }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="page-header">
      <el-page-header title="" @back="$router.push('/websites/dnspod')" :content="domain"></el-page-header>
      <p class="text-medium website-status">
      </p>
    </div>
    <el-tabs type="border-card" v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="解析记录" name="records">
        <el-row>
          <el-button type="primary" size="mini" @click="editRecords()" icon="el-icon-plus">添加记录</el-button>
          <el-button type="primary" size="mini" @click="syncRecords" icon="el-icon-refresh">记录同步</el-button>
          <el-dropdown split-button type="primary" size="mini" @command="recordsBatch">
            更多操作
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="开启">开启</el-dropdown-item>
              <el-dropdown-item command="暂停">暂停</el-dropdown-item>
              <el-dropdown-item command="删除">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-row>
        <el-table ref="multipleTable" :data="recordsList" tooltip-effect="dark" style="width: 100%"
          @selection-change="recordsSelectionChange" height="600" v-loading="loading" stripe
          class="text-extra-small hover-icon-table">
          <el-table-column type="selection" width="55" fixed="left">
          </el-table-column>
          <el-table-column prop="name" label="主机记录" width="300" show-overflow-tooltip fixed="left">
            <template v-slot="scope">
              <span>
                <i :class="scope.row.status === 'ENABLE' ? 'green el-icon-video-play' : 'red el-icon-video-pause'"></i>
                {{ scope.row.name }}
                <el-link :underline="false"><i class="el-icon-copy-document hover-icon"
                    @click="copy(scope.row.name)"></i></el-link>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="记录类型" width="100">
          </el-table-column>
          <el-table-column prop="value" label="记录值">
            <template v-slot="scope">
              <span>
                {{ scope.row.value }}
                <el-link :underline="false"><i class="el-icon-copy-document hover-icon"
                    @click="copy(scope.row.value)"></i></el-link>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="mx" label="优先级" width="80">
            <template v-slot="scope">
              <span v-if="scope.row.type === 'MX'">{{ scope.row.mx }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ttl" label="TTL" width="80">
          </el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template v-slot="scope">
              <el-link type="primary" :underline="false" @click="editRecords(scope.row)">编辑</el-link>
              <el-link type="primary" :underline="false" @click="toggleStatus(scope.row)">
                {{ scope.row.status === 'ENABLE' ? '暂停' : '开启' }}
              </el-link>
              <el-link type="danger" :underline="false" @click="deleteRecord(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total" :total="recordsList.length">
          </el-pagination>
        </div>
        <el-dialog :title="domain" :visible.sync="recordsVisiable" :close-on-click-modal="false"
          style="margin-top: -50px;" width="950px">
          <el-row>
            <el-col :span="11">
              <el-form :model="recordForm" label-width="80px" :rules="recordFormRules" ref="recordForm"
                v-loading="recordLoading">
                <el-row>
                  <el-form-item label="记录名" prop="name">
                    <el-input v-model="recordForm.name"></el-input>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="类型" prop="type">
                    <el-select v-model="recordForm.type" style="width: 100%" filterable>
                      <el-option v-for="item in recordTypeOptions" :key="item" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="记录值" prop="value">
                    <el-input type="textarea" v-model="recordForm.value" rows="6"></el-input>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="TTL" prop="ttl">
                    <el-select v-model="recordForm.ttl" style="width: 100%">
                      <el-option v-for="item in recordTtlOptions" :key="item" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="MX" prop="mx">
                    <el-select v-model="recordForm.mx" style="width: 100%">
                      <el-option v-for="item in recordMxOptions" :key="item" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-row>
              </el-form>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="12">
              <div class="grid-content record-content-box">
                <el-descriptions title="类型说明" :column="1" class="text-extra-small">
                  <el-descriptions-item v-for="item in typeDescriptions" :key="item.type" :label="item.type"
                    :label-class-name="recordForm.type === item.type ? 'blue' : ''"
                    :content-class-name="recordForm.type === item.type ? 'blue' : ''">
                    <span v-html="item.desc"></span>
                  </el-descriptions-item>
                </el-descriptions>
              </div>
            </el-col>
          </el-row>
          <div slot="footer" class="dialog-footer">
            <el-button @click="recordsVisiable = false">取 消</el-button>
            <el-button type="primary" @click="confirmEditRecord">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="Whois" name="whois" :loading="full_screen_loading">
        <div class="website-detail-box">
          <el-skeleton :loading="loading" animated :rows="15">
            <el-descriptions class="margin-top" title="域名注册基本信息" :column="1" border>
              <template slot="extra">
                <el-button type="primary" size="small" icon="el-icon-refresh" @click="getWhois">刷新</el-button>
              </template>
              <el-descriptions-item>
                <template slot="label">注册商</template>
                {{ whois.registrar }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">注册时间</template>
                {{ whois.creation_date }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">到期时间</template>
                {{ whois.expiration_date }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">更新时间</template>
                {{ whois.updated_date }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">DNSSEC状态</template>
                {{ whois.dnssec }}
              </el-descriptions-item>
              <el-descriptions-item label="域名状态">
                <div v-for="(item, idx) in whois.status" :key="idx">
                  {{ item }}
                </div>
              </el-descriptions-item>
            </el-descriptions>
            <br>
            <el-descriptions class="margin-top" title="域名注册者信息" :column="3" border>
              <el-descriptions-item>
                <template slot="label">公司</template>
                {{ whois.registrant.organization }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">姓名</template>
                {{ whois.registrant.name }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">邮箱</template>
                {{ whois.registrant.email }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">电话</template>
                {{ whois.registrant.phone }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">国家</template>
                {{ whois.registrant.country }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">城市/地区</template>
                {{ whois.registrant.city }}
              </el-descriptions-item>
            </el-descriptions>
            <br>
            <el-descriptions class="margin-top" title="域名DNS服务器" :column="1">
              <el-descriptions-item v-for="(item, idx) in whois.name_servers" :key="idx">
                <template slot="label">DNS{{ idx + 1 }}</template>
                {{ item }}
              </el-descriptions-item>
            </el-descriptions>
            <el-link type="danger" @click="destroyDomain()">注销域名</el-link>
          </el-skeleton>
        </div>
      </el-tab-pane>
      <el-tab-pane label="操作记录" name="logs">
        <p class="page-desc"><i class="el-icon-info"></i> 此处只显示在CRM的操作记录</p>
        <el-table :data="logsList" tooltip-effect="dark" style="width: 100%" height="600" v-loading="loading" stripe
          class="text-extra-small">
          <el-table-column prop="time" label="操作时间" width="160">
          </el-table-column>
          <el-table-column prop="operater" label="操作者" width="100">
          </el-table-column>
          <el-table-column prop="ip" label="操作IP" width="120">
          </el-table-column>
          <el-table-column label="操作内容" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="table-html" v-html="scope.row.content">
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="logsTotal"
            @size-change="changeLogsSize" @current-change="currentLogsChange" :page-sizes="[20, 50, 100, 200]"
            :page-size="logsSize">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Nav from '../../Global/Nav.vue'
export default {
  name: 'DomainDetail',
  components: {
    Nav
  },
  data() {
    return {
      uploadApi: this.$axios.defaults.baseURL + 'websites/backend/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      activeName: 'records',
      loading: true,
      full_screen_loading: true,
      domain: '',
      recordsList: [],
      multipleRecordsSelection: [],
      recordsVisiable: false,
      recordLoading: false,
      recordTypeOptions: [
        'A',
        'CNAME',
        'MX',
        'TXT',
        'AAAA',
        'NS',
        'CAA',
        'SRV',
        'HTTPS',
        'SVCB',
        'SPF',
        '显性URL',
        '隐性URL'
      ],
      recordTtlOptions: [
        600,
        60,
        3600,
        86400,
        604800
      ],
      recordMxOptions: [
        0,
        5,
        10,
        50
      ],
      recordForm: {
        id: '',
        name: '',
        domain: '',
        type: 'A',
        value: '',
        ttl: 600,
        mx: 0
      },
      typeDescriptions: [
        { type: 'A', desc: '将域名指向一个 IPv4 地址，如 8.8.8.8' },
        { type: 'CNAME', desc: '将域名指向另一个域名地址，如 www.xxx.com' },
        { type: 'MX', desc: '用于邮件服务器，根据邮件注册商提供的信息填写' },
        { type: 'TXT', desc: '文本信息，常用于域名验证' },
        { type: 'AAAA', desc: '将域名指向一个 IPv6 地址，如 ff06::c3' },
        { type: 'NS', desc: '域名服务器记录，指定域名交由其他 DNS 服务商' },
        { type: 'CAA', desc: '指定证书颁发机构，减少证书颁发风险' },
        { type: 'SRV', desc: '用于标识某台服务器使用了某个服务' },
        { type: 'HTTPS', desc: 'HTTPS 服务绑定记录，提升安全性与性能' },
        { type: 'SVCB', desc: '新型服务绑定记录类型，可绑定多个客户端与参数' },
        { type: 'SPF', desc: '指定发送邮件的服务器，反垃圾邮件方案' },
        { type: '显性URL', desc: '域名重定向到网页并<span class="red">显示</span>实际 URL(301, 双向备案)' },
        { type: '隐性URL', desc: '域名重定向到网页并<span class="red">隐藏</span>实际 URL(301, 双向备案)' }
      ],
      recordFormRules: {
        name: [
          { required: true, message: '记录名不能为空', trigger: 'commit' },
          { max: 254, message: '长度不能超过 254 个字符', trigger: 'commit' },
          {
            validator: (rule, value, callback) => {
              if (!value) return callback();
              const validPattern = /^[0-9a-zA-Z\-*@_\u4e00-\u9fa5]+$/;
              if (!validPattern.test(value)) {
                return callback(new Error('主机记录仅允许 0-9, a-z, -, *, @, _, 中文字符'));
              }
              const starCount = (value.match(/\*/g) || []).length;
              if (starCount > 1) {
                return callback(new Error('"*" 只允许出现一次'));
              }
              const atCount = (value.match(/@/g) || []).length;
              if (atCount > 1) {
                return callback(new Error('"@" 字符只允许存在一位'));
              }
              if (atCount === 1 && value[0] !== '@') {
                return callback(new Error('"@" 字符只允许出现在主机记录的起始位置'));
              }
              callback();
            },
            trigger: 'commit'
          }
        ],
        value: [
          { required: true, message: '记录值不能为空', trigger: 'commit' }
        ]
      },
      whois: {
        registrant: {},
        name_servers: []
      },
      logsList: [],
      logsTotal: 0,
      logsPage: 1,
      logsSize: 20
    }
  },
  created() {
    this.domain = this.$route.params.domain;
    this.getRecords();
  },
  mounted() {
    this.getRecords();
  },
  methods: {
    tabClick(tab) {
      switch (tab.name) {
        case 'info':
          this.getRecords();
          break;
        case 'whois':
          this.getWhois();
          break;
        case 'logs':
          this.getLogs();
          break;
      }
    },
    async getRecords() {
      await this.$axios.get(`/tencent/dnspod/records?domain=${this.domain}`).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.recordsList = response.data.data
        }
      })
    },
    copy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    recordsSelectionChange(val) {
      this.multipleRecordsSelection = val.map(item => item.record_id);
    },
    async recordsBatch(action) {
      if (this.multipleRecordsSelection.length > 0) {
        this.$confirm("确定要批量" + action + "吗?", '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          this.$axios.post(`/tencent/dnspod/records/toggle_status_batch`, {
            ids: this.multipleRecordsSelection,
            action: action,
            domain: this.domain
          }).then((response) => {
            this.loading = false;
            if (response.data.code === 200) {
              this.getRecords();
              this.$notify({
                title: '操作成功',
                message: "已保存",
                type: 'success'
              });
            }
          }).catch();
        })
      } else {
        this.$message({
          message: '未选择任何一条记录',
          type: 'error'
        });
      }
    },
    syncRecords() {
      this.loading = true;
      this.$axios.post(`/tencent/dnspod/records/sync`, { domain: this.domain }).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.getRecords();
          this.$notify({
            title: '操作成功',
            message: '解析记录已经刷新',
            type: 'success'
          });
        }
      }).catch();
    },
    editRecords(record = null) {
      if (record !== null) {
        this.recordForm = {
          id: record.id,
          name: record.name,
          domain: this.domain,
          type: record.type,
          value: record.value,
          ttl: record.ttl,
          mx: record.mx
        }
      } else {
        this.recordForm = {
          id: '',
          name: '',
          domain: this.domain,
          type: 'A',
          value: '',
          ttl: 600,
          mx: 0
        }
      }
      this.recordsVisiable = true;
    },
    confirmEditRecord() {
      this.$refs.recordForm.validate(valid => {
        if (valid) {
          this.recordLoading = true;
          this.$axios.post(`/tencent/dnspod/records/save`, this.recordForm).then((response) => {
            this.recordLoading = false;
            if (response.data.code === 200) {
              this.getRecords();
              this.recordsVisiable = false;
              this.$notify({
                title: '操作成功',
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    deleteRecord(row) {
      this.$confirm("确定要删除" + row.name + "的" + row.type + "记录吗?", '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$axios.post(`/tencent/dnspod/records/delete`, { id: row.id }).then((response) => {
          this.loading = false;
          if (response.data.code === 200) {
            this.getRecords();
            this.$notify({
              title: '操作成功',
              message: row.name + "的" + row.type + "记录已删除",
              type: 'success'
            });
          }
        }).catch();
      })
    },
    toggleStatus(row) {
      this.loading = true;
      this.$axios.post(`/tencent/dnspod/records/toggle_status`, {
        id: row.id,
        domain: this.domain
      }).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.getRecords();
          this.$notify({
            title: '操作成功',
            message: "已保存",
            type: 'success'
          });
        }
      }).catch();
    },
    async getWhois() {
      this.whois = {
        registrant: {},
        name_servers: []
      }
      this.full_screen_loading = true;
      this.loading = true;
      this.$axios.get(`/tencent/dnspod/whois?domain=${this.domain}`).then((response) => {
        this.full_screen_loading = false;
        this.loading = false;
        if (response.data.code === 200) {
          this.whois = response.data.data;
        }
      }).catch();
    },
    destroyDomain() {
      this.$axios.post(`/tencent/dnspod/destroy`, {
        domain: this.domain
      }).then((response) => {
        // if (response.data.code === 200) {
        //   this.whois = response.data.data;
        // }
      }).catch();
    },
    async getLogs() {
      this.loading = true;
      await this.$axios.get(`/tencent/dnspod/logs`, {
        params: {
          domain: this.domain,
          page: this.logsPage,
          size: this.logsSize
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.logsList = response.data.data.data;
          this.logsTotal = response.data.data.total;
        }
      });
    },
    changeLogsSize(val) {
      this.logsSize = val;
      this.getLogs();
    },
    currentLogsChange(val) {
      this.logsPagePage = val;
      this.getLogs();
    }
  }
}
</script>

<style scoped>
/deep/ .el-table th.el-table__cell>.cell {
  padding: 0 14px !important;
}

.hover-icon-table .hover-icon {
  display: none;
}

.hover-icon-table .el-table__row:hover .hover-icon {
  display: block;
}

.record-content-box {
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  padding: 10px;
  height: 420px;
}
</style>


// WEBPACK FOOTER //
// src/components/Modules/Websites/DomainsDetail.vue